import { render } from "./NewDataListView.vue?vue&type=template&id=0f886932"
import script from "./NewDataListView.vue?vue&type=script&lang=js"
export * from "./NewDataListView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__